export default {
    USER_AVATAR_UPDATED : 'user-avatar-updated',
    USER_UPDATED : 'user-updated',
}
